import { EventHandler } from "@cervval.js/client-html5-core/src/components/event.decorator";
import { BasePageName } from "./navigation.page";

export enum ENavigationLifeCycle {
    AfterPageHide = "afterPageHide",
    AfterPageShow = "afterPageShow",
    BeforePageHide = "beforePageHide",
    BeforePageShow = "beforePageShow"
}

/**
 * Navigation lifeCycle listeners
 * Used to manage page behaviors in application
 * 1 - beforePageShow
 * [Page is displayed]
 * 2 - afterPageShow
 * [Page lives]
 * [Navigation to other page is called]
 * 3 - beforePageHide
 * [Page is hidden]
 * 4 - afterPageHide
 */
export interface NavigationListeners {

    /**
     * Event triggered before the page is displayed when navigating to the page
     * 
     * (TODO)
     * Check if the page can be displayed, based on app customs handlers
     * Returns a code defined by the handlers (ex : 0 | 1 | 403 | 404)
     * [Compulsory] code 0: Navigation ok
     *
     * @param Event
     */
    beforePageShow?: EventHandler<LifeCycleEvent, EventInit>;

    /**
     * Event triggered after the page display  when navigating to the page
     * * WARNING : this does not mean the page is init and refreshed
     *
     * @param event
     */
    afterPageShow?: EventHandler<LifeCycleEvent, EventInit>;

    /**
     * Event triggered before the page will be hidden / destroyed when navigating to another page
     * 
     * (TODO)
     * Check if the page can be hidden, based on app customs handlers.
     * Returns a code defined by the handlers (ex : 0 | 1 | 403 | 404)
     * [Compulsory] code 0: Navigation ok
     *
     * @param event
     */
    beforePageHide?: EventHandler<LifeCycleEvent, EventInit>;

    /**
     * Event triggered after the page was hidden / destroyed when navigating to another page
     *
     * @param event
     */
    afterPageHide?: EventHandler<LifeCycleEvent, EventInit>;
}


/**
 * Event interface to share in lifeCycle listeners
 */
export interface LifeCycleEvent {

    /**
     * The page name for which the event is triggered
     */
    pageName: BasePageName;

    /**
     * The LifeCycle for which the event is triggered
     */
    navigationLifeCycle: ENavigationLifeCycle;

    /**
     * The pageName after navigation
     */
    pageNameAfterNavigation?: BasePageName;
}